import React from 'react';
import { Button } from 'react-bootstrap';
import GridOcorrencias from '~/Components/Ocorrencias/GridOcorrencias';

/**
 * Grid de Clientes com DblClick para stub de Situação.
 */
const GridClientes = ({
  dados,
  total,
  pagina,
  clienteSelecionado,
  onLinhaClick,
  onLinhaDblClick,
  onImprimir,
  onPaginaChange,
}) => {
  const colunas = [
    { key: 'codigo_conta', label: 'Código', width: 80 },
    { key: 'apelido_conta', label: 'Conta' },
    { key: 'quantidade', label: 'Qtd', width: 60 },
  ];

  const chave = clienteSelecionado
    ? `${clienteSelecionado.codigo_conta}-${clienteSelecionado.codigo_grupo_empresa}`
    : null;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <strong style={{ fontSize: 13 }}>Clientes</strong>
        <Button size="sm" variant="outline-primary" onClick={onImprimir}>
          Imprimir
        </Button>
      </div>
      <GridOcorrencias
        dados={dados}
        total={total}
        pagina={pagina}
        colunas={colunas}
        comSel={false}
        onLinhaClick={onLinhaClick}
        onLinhaDblClick={onLinhaDblClick}
        linhaSelecionada={chave}
        chaveSelecao={(item) => `${item.codigo_conta}-${item.codigo_grupo_empresa}`}
        onPaginaChange={onPaginaChange}
      />
    </div>
  );
};

export default GridClientes;
